"use strict";
// /<reference path="../../../../../typings/index.d.ts"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.load = void 0;
var React = require("react");
var ReactDOM = require("react-dom");
var ui_library_searchbar_1 = require("@eservice/ui-library-searchbar");
var l = require("lenovo");
var lodash_1 = require("lodash");
var BluebirdPromise = require("bluebird");
var filterData = [
    { key: 'all_supports', title: l.Translator.translate('all supports'), icon: 'glyphicon glyphicon-triangle-bottom', search: 'Realm.ALL', placeholder: l.Translator.translate('search lenovo support') },
    { key: 'pc_supports', title: l.Translator.translate('pc supports'), icon: 'icon-mse-pcg', search: 'Realm.PCG', placeholder: l.Translator.translate('search pc support') },
    { key: 'dcg_supports', title: l.Translator.translate('data center supports'), icon: 'icon-mse-dcg', search: 'Realm.DCG', placeholder: l.Translator.translate('search data center support') },
    { key: 'mobile_supports', title: l.Translator.translate('mobile supports'), icon: 'glyphicon icon-mse-mobile-l', search: 'Realm.MBG', placeholder: l.Translator.translate('search mobile support') },
    { key: 'moto_supports', title: l.Translator.translate('moto support'), icon: 'glyphicon icon-mse-mobile-m', search: 'Realm.MOTO', placeholder: l.Translator.translate('search moto support') },
    { key: 'smart_supports', title: l.Translator.translate('smart support'), icon: 'glyphicon icon-mse-smart', search: 'Realm.SMART', placeholder: l.Translator.translate('search smart support') },
];
var SearchBarWrapper = /** @class */ (function (_super) {
    __extends(SearchBarWrapper, _super);
    function SearchBarWrapper() {
        var _this = _super.call(this) || this;
        _this.getAutoCompleteXHR = null;
        _this.handleResize = function (e) {
            var placement = _this.props.placement;
            if (placement === 'masterhead') {
                _this.resetLength();
            }
            else {
                _this.setState(__assign(__assign({}, _this.state), { filterDataShowIcon: window.innerWidth < 500, showfilterIconOnly: window.innerWidth < 500 }));
            }
        };
        _this.getCurrentFilter = function (key) {
            return _this.state.filterData.filter(function (item) {
                return item.key === key;
            }).reduce(function (h) { return h; });
        };
        _this.onFilterUpdate = function (filterKey) {
            var filter = _this.getCurrentFilter(filterKey);
            _this.setState(__assign(__assign({}, _this.state), { filterValue: filter.title, filterKey: filterKey, filterIcon: filter.icon, placeholder: filter.placeholder }));
        };
        _this.onSearch = function (keyword, isProduct) {
            var filter = _this.getCurrentFilter(_this.state.filterKey);
            var domainurl = _this.getDomainUrl(filter.search);
            var url = '';
            if (_this.state.autoCompleteGrouping && keyword && isProduct) {
                var currentbrand = _this.getBrandByState(_this.state, keyword);
                if (currentbrand != "") {
                    url = _this.getDomainUrlByBrand(currentbrand) + '/products/' + keyword;
                    ;
                }
                else {
                    url = domainurl + '/products/' + keyword;
                }
            }
            else {
                url = domainurl + "/search?query=" + encodeURIComponent(keyword) + "&searchLocation=masthead_S";
            }
            window.location.href = url;
        };
        _this.onTriggerAutoCompleteSearch = function (keyword) {
            var that = _this;
            _this.setState(__assign(__assign({}, _this.state), { keyword: keyword }));
            if (keyword.trim().length >= _this.state.autoCompleteMinLength) {
                _this.getAutoSuggestions(keyword.trim()).then(function (suggestions) {
                    // need to workout if there is any products
                    var productSuggestions = suggestions.filter(function (item) { return item.grouping.toLowerCase() === 'products'; });
                    var autoCompleteGrouping = productSuggestions.length > 0;
                    that.setState({ autoCompleteOptions: suggestions, autoCompleteGrouping: autoCompleteGrouping });
                });
            }
        };
        _this.getAutoSuggestions = function (keyword) {
            var Brand = _this.getSiteBrand(_this.getCurrentFilter(_this.state.filterKey).search);
            return new BluebirdPromise(function (resolve, reject) {
                return $.ajax({
                    cache: true,
                    url: l.UrlUtility.getFullServicesPath('search/SearchAutoSuggest'),
                    dataType: 'json',
                    data: {
                        query: encodeURIComponent(keyword),
                        l: l.CultureUtility.getCurrentLanguage(),
                        Brand: Brand
                    },
                    success: function (response) {
                        var data = response.map(function (item) {
                            if (item.Brand != undefined && item.Brand != null) {
                                return { label: item.Title, id: item.ID, grouping: item.Type, brand: item.Brand };
                            }
                            else {
                                return { label: item.Title, id: item.ID, grouping: item.Type };
                            }
                        });
                        resolve(data);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        reject(textStatus);
                    }
                });
            });
        };
        _this.getDomainUrl = function (Realm) {
            var domainurl = "";
            try {
                for (var Key in window["config"].realms) {
                    if (window["config"].realms[Key].Id.toUpperCase() == Realm.toUpperCase()) {
                        domainurl = window["config"].realms[Key].DefaultSiteUrl;
                    }
                }
            }
            catch (e) { }
            if (domainurl == "") {
                domainurl = "http://support.lenovo.com";
            }
            if ("Realm.ALL".toUpperCase() == Realm.toUpperCase()) {
                var Country_Language = "";
                try {
                    Country_Language = "/" + window["config"].user.Country + "/" + window["config"].user.Language;
                }
                catch (e) { }
                return domainurl + Country_Language;
            }
            return domainurl;
        };
        _this.getSiteBrand = function (Realm) {
            var brand = "EBG,TPG,IPG,MOTO,PHONE,TABLET,SMART,SUGGESTBRAND";
            try {
                for (var Key in window["config"].realms) {
                    if (window["config"].realms[Key].Id.toUpperCase() == Realm.toUpperCase()) {
                        brand = window["config"].realms[Key].Brands.join(",") + ",SUGGESTBRAND";
                    }
                }
            }
            catch (e) { }
            if (brand == "") {
                brand = "EBG,TPG,IPG,MOTO,PHONE,TABLET,SMART,SUGGESTBRAND";
            }
            return brand;
        };
        _this.getDomainUrlByBrand = function (Brand) {
            var domainurl = "";
            try {
                for (var Key in window["config"].realms) {
                    if (Key.toUpperCase() == Brand.toUpperCase()) {
                        domainurl = window["config"].realms[Key].DefaultSiteUrl;
                    }
                }
            }
            catch (e) { }
            var Country_Language = "";
            try {
                Country_Language = "/" + window["config"].user.Country + "/" + window["config"].user.Language;
            }
            catch (e) { }
            if (domainurl == "") {
                domainurl = "http://pcsupport.lenovo.com";
            }
            domainurl = domainurl + Country_Language;
            return domainurl;
        };
        _this.getBrandByState = function (state, id) {
            var brand = "";
            try {
                for (var Key in state.autoCompleteOptions) {
                    if (id.toUpperCase() == state.autoCompleteOptions[Key].id.toUpperCase()) {
                        brand = state.autoCompleteOptions[Key].brand;
                    }
                }
            }
            catch (e) { }
            if (brand == undefined || brand == null || brand == "SUGGESTBRAND" || brand == "ALL") {
                return "";
            }
            return brand;
        };
        _this.state = {
            showFilter: true,
            keyword: '',
            size: 'normal',
            filterValue: '',
            filterKey: '',
            filterIcon: 'glyphicon glyphicon-triangle-bottom',
            filterData: filterData,
            placeholder: '',
            filterDataShowIcon: false,
            showfilterIconOnly: false,
            autoCompleteMinLength: 2,
            autoCompleteOptions: [],
            /*         autoCompleteAsyncAdditionalData: { 'l' : l.CultureUtility.getCurrentLanguage() },
                    autoCompleteAsyncUrl: l.UrlUtility.getFullServicesPath('search/SearchAotuSuggest'),
                    autoCompleteAsyncAttrMapping: {id: 'ID', label: 'Title'},
                    autoCompleteAsyncQueryMapping: 'query',
                    autoCompleteAsyncReturnDataStructure: [], */
            autoCompleteGrouping: false,
        };
        return _this;
    }
    SearchBarWrapper.prototype.componentWillMount = function () {
        var currentRealm = l.Common.getCurrentRealm();
        var filterValue = '';
        var filterKey = '';
        var showFilter = true;
        var placeholder = '';
        var filterIcon = 'glyphicon glyphicon-triangle-bottom';
        switch (currentRealm) {
            case l.RealmType.Pcg:
                filterValue = l.Translator.translate('pc supports');
                filterKey = 'pc_supports';
                showFilter = true;
                placeholder = l.Translator.translate('search pc support');
                filterIcon = "icon-mse-pcg";
                break;
            case l.RealmType.Dcg:
                filterValue = l.Translator.translate('data center supports');
                filterKey = 'dcg_supports';
                showFilter = true;
                placeholder = l.Translator.translate('search data center support');
                filterIcon = "icon-mse-dcg";
                break;
            case l.RealmType.Mbg:
                filterValue = l.Translator.translate('mobile supports');
                filterKey = 'mobile_supports';
                showFilter = true;
                placeholder = l.Translator.translate('search mobile support');
                filterIcon = "icon-mse-mobile-l";
                break;
            case l.RealmType.Moto:
                filterValue = l.Translator.translate('moto support');
                filterKey = 'moto_supports';
                showFilter = true;
                placeholder = l.Translator.translate('search moto support');
                filterIcon = "icon-mse-mobile-m";
                break;
            case l.RealmType.Smart:
                filterValue = l.Translator.translate('smart support');
                filterKey = 'smart_supports';
                showFilter = true;
                placeholder = l.Translator.translate('search smart support');
                filterIcon = "icon-mse-smart";
                break;
            default:
                filterValue = l.Translator.translate('all supports');
                filterKey = 'all_supports';
                showFilter = true;
                placeholder = l.Translator.translate('search lenovo support');
                filterIcon = "glyphicon glyphicon-triangle-bottom";
        }
        this.setState(__assign(__assign({}, this.state), { filterValue: filterValue, filterKey: filterKey, showFilter: showFilter, placeholder: placeholder, filterIcon: filterIcon }));
    };
    SearchBarWrapper.prototype.componentDidMount = function () {
        window.addEventListener('resize', (0, lodash_1.debounce)(this.handleResize, 100));
        this.resetLength();
    };
    SearchBarWrapper.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleResize);
    };
    SearchBarWrapper.prototype.resetLength = function () {
        //hack search bar length here?
        var placement = this.props.placement;
        if (placement === 'masterhead') {
            var totalWidth = document.querySelector('#header-desktop > .navbar-collapse').offsetWidth;
            var leftMenuWidth = document.querySelector('#header-desktop > .navbar-collapse > .navbar-nav').offsetWidth;
            var rightMenuWidth = document.querySelector('#header-desktop > .navbar-collapse > .navbar-right').offsetWidth;
            var targetWidth = totalWidth - leftMenuWidth - rightMenuWidth - 100;
            console.log("width should be ".concat(targetWidth, "px"));
            document.querySelector('#header-desktop > .navbar-collapse > .navbar-search').style.width = "".concat(targetWidth, "px");
            this.setState(__assign(__assign({}, this.state), { filterDataShowIcon: targetWidth < 400, showfilterIconOnly: targetWidth < 400 }));
        }
    };
    SearchBarWrapper.prototype.render = function () {
        var placement = this.props.placement;
        return (React.createElement(ui_library_searchbar_1.LSearchBar, { showFilter: this.state.showFilter, filterData: this.state.filterData, filterValue: this.state.filterValue, filterDataShowIcon: this.state.filterDataShowIcon, showfilterIconOnly: this.state.showfilterIconOnly, filterIcon: this.state.filterIcon, placeholder: this.state.placeholder, keyword: this.state.keyword, size: this.state.size, autoComplete: true, autoCompleteMinLength: this.state.autoCompleteMinLength, onFilterUpdate: this.onFilterUpdate, onSearch: this.onSearch, onKeywordUpdate: this.onTriggerAutoCompleteSearch, autoCompleteGrouping: this.state.autoCompleteGrouping, autoCompleteData: this.state.autoCompleteOptions }));
    };
    return SearchBarWrapper;
}(React.Component));
var load = function (element, params) {
    ReactDOM.render(React.createElement(SearchBarWrapper, __assign({}, params)), element);
};
exports.load = load;
